import React, { useContext, useEffect, useMemo, useState } from "react";
import FormulaGenerator from "../../../FormulaGenerator";
import "./index.scss";
import { getStepInfo } from "../../stepInfo";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentySelectTooth = ({
  stepId,
  toggleNextBtnState
}) => {
  const {
    language
  } = useTranslation();
  const {
    isPatient,
    dentalData,
    setStepFormula,
    setFormulaBeforeTreatment
  } = useContext(StepContext);

  function setData(data) {
    setStepFormula(stepId, data);
    setFormulaBeforeTreatment(data);
    toggleNextBtnState(false);
  }

  console.log(dentalData); // Disable next btn

  const [runOnce, setRunOnce] = useState(false);
  useEffect(() => {
    if (!runOnce) {
      if (isPatient && (!dentalData || !dentalData.hasOwnProperty("tooth") || !dentalData.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "emptyTooth")))) {
        toggleNextBtnState(true);
      }

      setRunOnce(true);
    }
  }, [dentalData, runOnce, toggleNextBtnState, isPatient]);
  const formulaHelperText = useMemo(() => {
    return getStepInfo(language, stepId)?.formulaHelperText || "";
  }, [language, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "adentySelectTooth"
  }, /*#__PURE__*/React.createElement(FormulaGenerator, {
    projectData: dentalData,
    setProjectDentalData: setData,
    initialSelection: "adentySelectTooth",
    availableSwitchers: ["top", "bottom", "base"],
    formulaHelperText: formulaHelperText
  }));
};

export default AdentySelectTooth;